const routes = [
  {
    index: true,
    label: 'Etem Kocaaslan',
    path: '/',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
];

export default routes;
